// import { Link, useLocation } from "react-router-dom";

// export default function DynamicBreadcrumb({ title }) {
//   const location = useLocation();

//   const pathnames = location.pathname
//     .split("/")
//     .filter((x) => x);


//   const formatText = (text) => {
//     return text
//       .replace(/-/g, " ")
//       .replace(/\b\w/g, (char) => char.toUpperCase());
//   };
  

//   return (
//     <div className="page-title-area">
//       <div className="container">
//         <div className="page-title-content">
//           <h2>{title || formatText(pathnames[pathnames.length - 1] || "Home")}</h2>

//           <ul>
//             <li>
//               <Link to="/">Home</Link>
//             </li>

//             {pathnames.map((value, index) => {
//               const to = `/${pathnames.slice(0, index + 1).join("/")}`;
//               const isLast = index === pathnames.length - 1;

//               return (
//                 <li key={to} className={isLast ? "active" : ""}>
//                   {isLast ? (
//                       title || formatText(value)
//                   ) : (
//                     <Link to={to}>{formatText(value)}</Link>
//                   )}
//                 </li>
//               );
//             })}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// }

import { Link, useLocation } from "react-router-dom";

export default function DynamicBreadcrumb({ title }) {
  const location = useLocation();

  const pathnames = location.pathname.split("/").filter((x) => x);

  const formatText = (text) => {
    return text
      .replace(/-/g, " ")
      .replace(/\band\b/gi, "&")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // Define non-clickable segments
  const nonClickableSegments = [
    "industries",
    "solutions",
    "services",
    "digital-marketing",
  ];

  return (
    <div className="page-title-area">
      <div className="container">
        <div className="page-title-content">
          <h2>
            {title || formatText(pathnames[pathnames.length - 1] || "Home")}
          </h2>

          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>

            {pathnames.map((value, index) => {
              const to = `/${pathnames.slice(0, index + 1).join("/")}`;
              const isLast = index === pathnames.length - 1;
              const isNonClickable = nonClickableSegments.includes(
                value.toLowerCase(),
              );

              return (
                <li key={to} className={isLast ? "active" : ""}>
                  {isLast || isNonClickable ? (
                    <span>
                      {isLast ? title || formatText(value) : formatText(value)}
                    </span>
                  ) : (
                    <Link to={to}>{formatText(value)}</Link>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
